module.exports = __webpack_public_path__ + "static/media/pdf.ec012222.svg";